import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Selects Design Guidelines",
  "title": "Select",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="select" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  The Select component allows users to choose one or more options from a list.
  It is used in forms for users to submit data.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.4015444015444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAd0lEQVQoz53RwQrEIAxF0f7/d7pxFZP0RZQ2HVAKYwu19Kx0cSHRBaO1AWBmmFn+L2YWYwwhEJE266mfn2IAKSVuiMjMygmweQxARGqt7r4PtsnYfXJmLqUcI3d/Favq91hEPsYAmDnnvF823l7s3H9FVeXm/to/3yoHTEysR8kAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/static/447f000909e78239df03a23f8b48d01d/e3189/selects-intro-image.png",
            "srcSet": ["/static/447f000909e78239df03a23f8b48d01d/a2ead/selects-intro-image.png 259w", "/static/447f000909e78239df03a23f8b48d01d/6b9fd/selects-intro-image.png 518w", "/static/447f000909e78239df03a23f8b48d01d/e3189/selects-intro-image.png 1035w", "/static/447f000909e78239df03a23f8b48d01d/aa440/selects-intro-image.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <hr></hr>
      <h2>{`Select vs. Dropdown`}</h2>
      <p>{`While the Select and Dropdown components can look similar, they have different functions.`}</p>
      <ul>
        <li parentName="ul">{`Use the Select component inside a form where users are selecting from a list of options and submitting data.`}</li>
        <li parentName="ul">{`Use the Dropdown component to display a list of menu options.`}</li>
      </ul>
      <hr></hr>
      <h2>{`Multiselect`}</h2>
      <p>{`Multiselects are exactly what the name implies – A Select input that allows the user to choose multiple values to be submitted at the same time. Previously selected options may be removed with the associated close/remove button.`}</p>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.69884169884169%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABC0lEQVQY032PPUvDYBCAs/kHxEH8N/6Erh3s4OKmdpY6OTqIorYIkS5+7I4OxVasCiKiicWvOCShaPK+d/cmedOcFFqwgebhhlueOx4DJwFAGDJasBAjZ0aK0lRpTVorrRWMQYQieWhGyn51WlfWTbfXaVvtzsv72xeEoRRSBAKkLJKTRF13nd39B/PUbpz3jsynvoiZWQ0yyhgU4WSIkTumEDTHdPccbB7/bph+renVmt7WibteD+9t0vF/Py+DkMhZ/+Dic6bkzC99L1ScubIzW/4wFn/OLokzFHKqjBIoTYLWo7ey51cb/lrdXz10l3fcynZ4a2GaoJz+eVQfR8QZ8WA8TMwYRbnmP57QsDIB2nTTAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/static/3a13c278b9450c81ad1ba84496876c8e/e3189/multi-select-example.png",
            "srcSet": ["/static/3a13c278b9450c81ad1ba84496876c8e/a2ead/multi-select-example.png 259w", "/static/3a13c278b9450c81ad1ba84496876c8e/6b9fd/multi-select-example.png 518w", "/static/3a13c278b9450c81ad1ba84496876c8e/e3189/multi-select-example.png 1035w", "/static/3a13c278b9450c81ad1ba84496876c8e/aa440/multi-select-example.png 1500w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      